import { render } from "./UiPropGutters.vue?vue&type=template&id=000bdf91&scoped=true"
import script from "./UiPropGutters.vue?vue&type=script&lang=js"
export * from "./UiPropGutters.vue?vue&type=script&lang=js"

import "./UiPropGutters.vue?vue&type=style&index=0&id=000bdf91&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000bdf91"]])

export default __exports__